import { render, staticRenderFns } from "./TaskSidebarComponent.vue?vue&type=template&id=45da4fe7&scoped=true"
import script from "./TaskSidebarComponent.vue?vue&type=script&lang=js"
export * from "./TaskSidebarComponent.vue?vue&type=script&lang=js"
import style0 from "./TaskSidebarComponent.vue?vue&type=style&index=0&id=45da4fe7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da4fe7",
  null
  
)

export default component.exports